/*
 *
 * PayBalance constants
 *
 */
import { utils } from '../../devUtils';

export const DEFAULT_ACTION = '/PayBalance/DEFAULT_ACTION';
export const FETCH_PAY_BALANCE_SUCCESS = '/PayBalance/FETCH_PAY_BALANCE_SUCCESS';
export const ADD_CARD_SUCCESS = 'PayBalance/ADD_CARD_SUCCESS';
export const OTP_SUBMIT = 'PayBalance/OTP_SUBMIT';

const PAY_BALANCE_CONSTANT = Object.freeze({
  SET_WALLET_BALLANCE: 'PayBalance/SET_WALLET_BALLANCE',
  SET_NSDL_WALLET_BALLANCE: 'PayBalance/SET_NSDL_WALLET_BALLANCE',
  XML_M2P_KYC_SUCCESS: 'PayBalance/XML_M2P_KYC_SUCCESS',
  XML_KYC_INFO: 'Complete Aadhar XML KYC',
  DOWNLOAD_XML_KYC: 'Please Download the Aadhar XML then Click on Complete your KYC',
  LINK_AADHAR_XML_KYC: 'https://resident.uidai.gov.in/offline-kyc',
  SET_GENERATE_OTP_YSC: 'PayBalance/SET_GENERATE_OTP_YSC',
  SET_YBL_OTP_SUCCESS: 'PayBalance/SET_YBL_OTP_SUCCESS',
  SET_YBL_OTP_VERIFIED: 'PayBalance/SET_YBL_OTP_VERIFIED',
  FETCH_YBL_MIN_KYC: 'PayBalance/FETCH_YBL_MIN_KYC',
});

export const YES_BANK_CONSENT = `
I certify that I have read and accept the “Terms and Conditions” and “Secure Usage Guidelines” and 
provide consent for the Yes Bank Prepaid Card Account Registration.`;

export const YES_BANK_POP_UP = `
Dear Customer, Please Share The Additional Profile Information For 
Bank's Due Diligence And KYC`;

export const CARD_SERIES = [
  { name: 'WAVE', number: '4624940' },
  { name: 'ZICO', number: '46249456' },
  { name: 'WHEELS', number: '46249457' },
  { name: 'PETRO', number: '46249455' },
  { name: "OHRI'S", number: '46249458' },
  { name: 'KOHINOOR', number: '4624944' },
  { name: "BAYER'S", number: '52884917' },
  { name: 'ZEON', number: '52884906' },
  { name: 'ZEAL', number: '54497001' },
  { name: 'ZINGER', number: '4624946' },
  { name: 'KUBER', number: '462494' },
  { name: 'KUBER', number: '528849' },
  { name: 'BOMB', number: '5288490' },
  { name: 'BOMB', number: '5507850' },
  { name: 'TAJ', number: '443682' },
  { name: 'KFC', number: '608108' },
  { name: 'METRO', number: '608268' },
  { name: 'KUBERD', number: '4624946' },
  { name: 'TAJGIF', number: '4624946' },
  { name: 'KFCGIF', number: '4624946' },
  { name: 'METROC', number: '4624946' },
  { name: 'KUBER', number: '6081080' },
  { name: 'KUBERGIFTCARD', number: '443682' },
  { name: 'BAYERGIFTCARD', number: '6081080' },
  { name: 'ZEONGIFTCARD', number: '6081080' },
  { name: 'KUBERGIFTCARDYES0', number: '528849' },
  { name: 'KUBERGIFTCARDYES1', number: '528849' },
  { name: 'KUBERGIFTCARDYES2', number: '528849' },
  { name: 'ZSC', number: ' ' },
];

/**
 * @desc condtion removed for active check only
 */
// item.CardStatus === 'Active' &&
// export const CALICULATE_MULTIWALLET_TOTAL = (array) => {
//   let total = 0;
//   array.forEach((item) => {
//     if (item.multipurpose_card) {
//       item.ProductInfo.Details.forEach((product) => {
//         total += parseFloat(product.Amount);
//       });
//     }
//   });
//   return total;
// };

/**
 * @param {card_series} @default CARD_SERIES always
 */
export const CHECK_CARD_NAME = (cardValue, card_series = CARD_SERIES) => {
  let cardName = 'ZSC';
  card_series.forEach((element) => {
    if (utils.lodashStartsWith(element.number, cardValue.substring(0, 6))) {
      cardName = element.name;
    }
  });
  return cardName;
};

export { PAY_BALANCE_CONSTANT };



// WEBPACK FOOTER //
// client/containers/PayBalance/constants.js